import BorrowerMailboxBanner from './borrower-mailbox-banner';

export default BorrowerMailboxBanner;
